import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

export interface LeagueRowProps {
  name: string;
  logoUrl: string | null;
  /** Appended to the name (` · 2025`) — pass only when it disambiguates. */
  season?: string;
  /** Link target: the whole row navigates and ends with a chevron. */
  to?: string;
  /** Secondary line under the name. */
  meta?: React.ReactNode;
  /** Right-side slot for non-link rows (e.g. admin controls). */
  trailing?: React.ReactNode;
  className?: string;
  testId?: string;
}

/**
 * League list row inside a country card: 24px logo, name (+ optional season
 * and meta line) and either a chevron (link rows) or a trailing slot.
 */
export const LeagueRow: React.FC<LeagueRowProps> = ({
  name,
  logoUrl,
  season,
  to,
  meta,
  trailing,
  className,
  testId,
}) => {
  const content = (
    <>
      {logoUrl && (
        <img className={styles.logo} src={logoUrl} alt="" width={24} height={24} decoding="async" />
      )}
      <span className={styles.body}>
        <span className={styles.name}>
          {name}
          {season && <span className={styles.season}> · {season}</span>}
        </span>
        {meta && <span className={styles.meta}>{meta}</span>}
      </span>
      {to ? <i className={`icon-chevron-right ${styles.chevron}`} aria-hidden="true" /> : trailing}
    </>
  );

  const classes = [styles.row, to && styles.link, className].filter(Boolean).join(' ');

  return to ? (
    <Link to={to} className={classes} data-testid={testId}>{content}</Link>
  ) : (
    <div className={classes} data-testid={testId}>{content}</div>
  );
};

export default LeagueRow;
